require("./heatmap/HeatmapSeries");

require("./heatmap/HeatmapView");


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/chart/heatmap.js
// module id = 742
// module chunks = 0